import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

const TONES = {
  computes: 'border-computes/25 bg-computes/10 text-computes',
  locked: 'border-projected/30 bg-projected/10 text-[#9a6212]',
  neutral: 'border-line bg-surface text-muted',
  recorded: 'border-recorded/25 bg-recorded/10 text-recorded',
} as const

export function StatePill({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: keyof typeof TONES
  children: ReactNode
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-control border px-2.5 py-1 font-mono text-[10.5px] font-medium',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
